// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__Yfy6l","head":"ProcedureTableInfo_head__3BruS"};